import { TUTORIAL_PANEL } from "../constants/identifiers";
import defaultDesktopViewLayout from "../viewLayouts/defaultDesktopViewLayout";
import defaultMobileLandscapeViewLayout from "../viewLayouts/defaultMobileLandscapeViewLayout";
import defaultMobileView from "../viewLayouts/defaultMobileView";
import defaultTabletViewLayout from "../viewLayouts/defaultTabletViewLayout";

let defaultRightPanelMode = TUTORIAL_PANEL;
//#!if iOS === true
// defaultRightPanelMode = null;
//#!endif

export const appState = {
  selectedItems: [],

  selectedMarkers: [],
  selectedSyncItems: [],
  desktopOpenViews: defaultDesktopViewLayout,
  tabletOpenViews: defaultTabletViewLayout,
  mobileLandscapeOpenViews: defaultMobileLandscapeViewLayout,
  mobileView: defaultMobileView,
  scrollingIsLocked: true,
  rightPanelMode: defaultRightPanelMode,
  leftPanelMode: null,
  notificationTab: 0
};
